/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsColorCollection,
    SharedserviceMelcoModelsColorCollectionFromJSON,
    SharedserviceMelcoModelsColorCollectionFromJSONTyped,
    SharedserviceMelcoModelsColorCollectionToJSON,
    SharedserviceMelcoModelsDesignElementColor,
    SharedserviceMelcoModelsDesignElementColorFromJSON,
    SharedserviceMelcoModelsDesignElementColorFromJSONTyped,
    SharedserviceMelcoModelsDesignElementColorToJSON,
    SharedserviceMelcoModelsDesignLetteringElement,
    SharedserviceMelcoModelsDesignLetteringElementFromJSON,
    SharedserviceMelcoModelsDesignLetteringElementFromJSONTyped,
    SharedserviceMelcoModelsDesignLetteringElementToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesignElement
 */
export interface SharedserviceMelcoModelsDesignElement {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    editable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    is_required?: boolean;
    /**
     * 
     * @type {SharedserviceMelcoModelsDesignElementColor}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    color?: SharedserviceMelcoModelsDesignElementColor;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    color_collection_id?: string | null;
    /**
     * 
     * @type {SharedserviceMelcoModelsColorCollection}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    color_collection?: SharedserviceMelcoModelsColorCollection;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    default_color_id?: string | null;
    /**
     * 
     * @type {SharedserviceMelcoModelsDesignLetteringElement}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    lettering?: SharedserviceMelcoModelsDesignLetteringElement;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    active_color_group_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesignElement
     */
    lettering_id?: string | null;
}

export function SharedserviceMelcoModelsDesignElementFromJSON(json: any): SharedserviceMelcoModelsDesignElement {
    return SharedserviceMelcoModelsDesignElementFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesignElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'is_required': !exists(json, 'is_required') ? undefined : json['is_required'],
        'color': !exists(json, 'color') ? undefined : SharedserviceMelcoModelsDesignElementColorFromJSON(json['color']),
        'color_collection_id': !exists(json, 'color_collection_id') ? undefined : json['color_collection_id'],
        'color_collection': !exists(json, 'color_collection') ? undefined : SharedserviceMelcoModelsColorCollectionFromJSON(json['color_collection']),
        'default_color_id': !exists(json, 'default_color_id') ? undefined : json['default_color_id'],
        'lettering': !exists(json, 'lettering') ? undefined : SharedserviceMelcoModelsDesignLetteringElementFromJSON(json['lettering']),
        'active_color_group_id': !exists(json, 'active_color_group_id') ? undefined : json['active_color_group_id'],
        'lettering_id': !exists(json, 'lettering_id') ? undefined : json['lettering_id'],
    };
}

export function SharedserviceMelcoModelsDesignElementToJSON(value?: SharedserviceMelcoModelsDesignElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'editable': value.editable,
        'is_required': value.is_required,
        'color': SharedserviceMelcoModelsDesignElementColorToJSON(value.color),
        'color_collection_id': value.color_collection_id,
        'color_collection': SharedserviceMelcoModelsColorCollectionToJSON(value.color_collection),
        'default_color_id': value.default_color_id,
        'lettering': SharedserviceMelcoModelsDesignLetteringElementToJSON(value.lettering),
        'active_color_group_id': value.active_color_group_id,
        'lettering_id': value.lettering_id,
    };
}


